import { ScreenAssistant } from '@dms/screen'

export default ScreenAssistant
